/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Calendar_Meta_DescriptionInputs */

const ja_calendar_meta_description = /** @type {(inputs: Calendar_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PLAYBRAINが制作したeスポーツ大会やライブ配信をご覧ください。League of Legends、Rainbow Six Siege、eFootballなど人気タイトルを中心に、競技大会配信、ライブイベント、ゲームコンテンツ制作の実績をご紹介します。`)
};

const en_calendar_meta_description = /** @type {(inputs: Calendar_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Watch esports broadcasts and livestream productions created by PLAYBRAIN. Featuring League of Legends, Rainbow Six Siege, eFootball, and other major titles, our productions showcase professional tournament broadcasts, live events, and gaming content.`)
};

/**
* | output |
* | --- |
* | "Watch esports broadcasts and livestream productions created by PLAYBRAIN. Featuring League of Legends, Rainbow Six Siege, eFootball, and other major titles, ..." |
*
* @param {Calendar_Meta_DescriptionInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const calendar_meta_description = /** @type {((inputs?: Calendar_Meta_DescriptionInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_Meta_DescriptionInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_calendar_meta_description(inputs)
	return en_calendar_meta_description(inputs)
});